<template>
  <v-card flat dense>
    <v-card-title>
      {{ $t('ITEM.CREATE') }} {{ $t('LINKED_ADDRESSES.ITEM') }}
      <v-spacer />
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <errors :errors="errorMessages" />
      <v-form v-model="valid">
        <address-linked-form
          v-model="address"
          :person-id="personId"
          :errors="errors"
          @update-prop="clearErrorByName($event)"
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn depressed color="primary" :disabled="!valid" @click="create">
        {{ $t('BUTTON.SAVE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import AddressLinkedForm from '@/modules/addresses/components/forms/AddressLinkedForm';

export default {
  name: 'CreateLinkedAddress',

  components: {
    AddressLinkedForm,
    Errors: () => import('@/modules/_global/_components/Errors')
  },

  mixins: [errors],

  props: {
    personId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      valid: false,
      errorMessages: [],
      address: {}
    };
  },

  methods: {
    ...mapActions('person', ['storeLinkedAddress']),

    cancel() {
      this.$emit('cancel');
    },

    create() {
      this.storeLinkedAddress({
        personId: this.personId,
        address: this.address
      })
        .then(({ data }) => {
          this.$emit('created', data.data);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
          this.errorMessages = [this.extractErrorMessage(response)];
        });
    },

    extractErrorMessage(response = {}) {
      return response.data && response.data.message;
    }
  }
};
</script>
